import { message } from 'antd';

export default {
  namespace: 'user',
  state: {
    userInfo: {}
  },
  reducers: {
    setUserInfo(state, { response: userInfo }) {
      return {
        ...state,
        userInfo,
      };
    },
  },
  effects: {
    * persistence({ payload }, { put, call }) {
      try {
        const response = window.localStorage.getItem('token');
        yield put({ type: 'setUserInfo', response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setUserInfo', response: {} });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/common/user.js